import React, { useEffect, useRef, useState } from "react";

const IconBubble = ({ children, color = "bg-white" }) => (
  <div
    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl shadow-sm ${color} text-xl`}
  >
    {children}
  </div>
);

const Tooltip = ({ children }) => (
  <span className="group relative inline-flex items-center ml-1">
    <span className="cursor-help text-xs text-slate-400">ⓘ</span>

    <span
      className="
      pointer-events-none
      absolute left-1/2 top-6 z-50
      w-56 -translate-x-1/2
      rounded-2xl bg-slate-900
      px-3 py-2
      text-xs leading-relaxed text-white
      opacity-0 shadow-xl
      transition
      group-hover:opacity-100
    "
    >
      {children}
    </span>
  </span>
);

const RateMeOverlay = ({
  open,
  onClose,
  userRecordingUrl,
  recordingChecked,
  setRecordingChecked,
  isPlayingReview,
  setIsPlayingReview,
  segment,
  assessment,
  subject,
  file,
  chapterTitle,
}) => {
  const reviewAudioRef = useRef(null);
  const [questionText, setQuestionText] = useState("");

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  useEffect(() => {
    if (!open) {
      setQuestionText("");
      setIsPlayingReview?.(false);

      if (reviewAudioRef.current) {
        reviewAudioRef.current.pause();
        reviewAudioRef.current = null;
      }
    }
  }, [open, setIsPlayingReview]);

  useEffect(() => {
    return () => {
      if (reviewAudioRef.current) {
        reviewAudioRef.current.pause();
      }
    };
  }, []);

  const playReviewRecording = () => {
    if (!userRecordingUrl) return;

    if (reviewAudioRef.current) {
      reviewAudioRef.current.pause();
      reviewAudioRef.current.currentTime = 0;
    }

    const player = new Audio(userRecordingUrl);
    reviewAudioRef.current = player;

    setRecordingChecked(true);
    setIsPlayingReview?.(true);

    player.onended = () => {
      setIsPlayingReview?.(false);
    };

    player.onerror = () => {
      setIsPlayingReview?.(false);
    };

    player.play();
  };

 const handleSend = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    alert("Please log in to send a Rate me request.");
    return;
  }

  if (!assessment?.audio_id || !assessment?.audio_url) {
    alert("Recording is missing. Please try recording again.");
    return;
  }

  try {
    const chapterDisplay =
  chapterTitle ||
  file?.chapterTitle ||
  file?.title ||
  file?.name ||
  file?.label ||
  file?.file;

const payload = {
  subject: {
    author: subject.author,
    title: subject.title,
    language: subject.language,
    type: subject.type,
    owner: subject.owner || null,
    course_key: subject.course_key || null,
  },

  // Keep this as the stable chapter/file key.
  file: typeof file === "string" ? file : file?.file,

  // Human-readable display title.
  chapterTitle: chapterDisplay,

  anchor: {
    text: segment.text,
    start: segment.start,
    end: segment.end,
  },

  content: questionText.trim(),
  audio_id: assessment.audio_id,
  audio_url: assessment.audio_url,
  is_private: assessment.is_private ?? true,
  assessment,
};

    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/comments/rate-me`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) {
      throw new Error(`Rate me request failed: ${res.status}`);
    }

    onClose?.();
  } catch (err) {
    console.error("Failed to send Rate me request:", err);
    alert("Could not send Rate me request. Please try again.");
  }
};
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 backdrop-blur-md px-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
        w-full max-w-xl
        overflow-hidden
        rounded-[32px]
        border border-white/70
        bg-white
        shadow-2xl
        animate-in fade-in zoom-in-95 duration-200
      "
      >
        {/* HEADER */}
        <div className="relative overflow-hidden bg-gradient-to-br from-violet-50 via-white to-blue-50 border-b border-slate-100 px-7 pt-7 pb-6">

          <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-violet-300/20 blur-3xl"/>
          <div className="absolute -bottom-16 -left-16 w-40 h-40 rounded-full bg-blue-300/20 blur-3xl"/>

          <button
            onClick={onClose}
            className="
            absolute right-4 top-4
            h-10 w-10 rounded-full
            border border-slate-200
            bg-white
            text-slate-500
            shadow-sm
            hover:scale-105
            transition
          "
          >
            ✕
          </button>

          <div className="inline-flex items-center gap-2 rounded-full bg-violet-100 border border-violet-200 px-4 py-2 text-xs font-bold text-violet-700">
            <span>⚔️</span>
AI vs Human Verdict
          </div>

          <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-900">
            Ask humans
          </h2>

         

          {/* duel cards */}
         {/* duel cards */}
<div className="mt-5 grid grid-cols-2 gap-3">

  <div className="rounded-3xl border border-blue-200 bg-blue-50 p-4">
    <div className="flex gap-3 items-center">
      <IconBubble>🤖</IconBubble>

      <div>
        <div className="font-black text-slate-900">
          AI verdict issued
        </div>

        <div className="text-xs text-slate-500 flex items-center">
          Already scored
          <Tooltip>
            AI already analyzed your pronunciation, rhythm and intonation.
          </Tooltip>
        </div>
      </div>
    </div>
  </div>


  <div className="rounded-3xl border border-violet-200 bg-violet-50 p-4">
    <div className="flex gap-3 items-center">
      <IconBubble>🧑</IconBubble>

      <div>
        <div className="font-black text-slate-900">
          Awaiting human verdict
        </div>

        <div className="text-xs text-slate-500 flex items-center">
          Ratings + comments
          <Tooltip>
            Teachers and students can rate your attempt and leave comments.
          </Tooltip>
        </div>
      </div>
    </div>
  </div>

</div>

          <p className="mt-4 text-xs text-slate-500 leading-relaxed">
            After posting, you can delete your request. View all Rate me requests
            and comments using the <span className="font-bold">Comments</span> button above.
          </p>

        </div>


        {/* BODY */}
        <div className="p-7 space-y-5">

          {/* Recording */}
          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">

            <div className="flex gap-3 items-start">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-100 text-lg">
                ▶
              </div>

              <div className="flex-1">
                <h3 className="font-black text-slate-900">
                  Check your recording
                </h3>

                <p className="mt-1 text-sm text-slate-600">
                  Make sure your mic behaved.
                </p>

                <button
                  disabled={!userRecordingUrl}
                  onClick={playReviewRecording}
                  className={[
                    "mt-4 w-full rounded-2xl px-4 py-3 font-black transition-all",
                    recordingChecked
                      ? "bg-green-100 text-green-700 border border-green-300 hover:bg-green-200"
                      : "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg hover:-translate-y-0.5",
                    !userRecordingUrl
                      ? "opacity-50 cursor-not-allowed"
                      : "",
                  ].join(" ")}
                >
                  {isPlayingReview
                    ? "Playing..."
                    : recordingChecked
                      ? "✓ Checked — play again"
                      : "Play my attempt"}
                </button>

                <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
                  If you do not hear your voice, check microphone settings.
                  Another tab may be using the microphone.
                </div>

              </div>
            </div>

          </div>


          {/* Optional ask */}
          <div className="rounded-3xl border border-slate-200 p-5 shadow-sm">
            <div className="flex items-center gap-2 font-black text-slate-900 mb-3">
              <span>💬</span>
              Ask something specific
              <span className="text-sm text-slate-400 font-semibold">
                optional
              </span>
            </div>

            <textarea
              value={questionText}
              onChange={(e)=>setQuestionText(e.target.value)}
              placeholder="Example: Does my intonation sound natural?"
              className="
                w-full h-24 resize-none
                rounded-2xl border border-slate-200
                bg-slate-50
                px-4 py-3
                text-sm
                outline-none
                focus:bg-white
                focus:ring-4
                focus:ring-violet-100
                focus:border-violet-300
              "
            />
          </div>


          {/* Submit */}
          <button
  type="button"
  disabled={!recordingChecked}
  onClick={handleSend}
  style={{
    background: recordingChecked
      ? "linear-gradient(135deg,#7c3aed,#a21caf)"
      : "#e2e8f0",
    color: recordingChecked ? "#ffffff" : "#94a3b8",
  }}
  className="
    w-full h-14 rounded-2xl
    flex items-center justify-center gap-3
    font-black text-base
    shadow-lg
    transition-all duration-200
  "
>
  <span style={{fontSize:"18px"}}>🚀</span>
  <span>Send</span>
</button>

          <p className="text-center text-xs text-slate-400">
            Humans may disagree with the robot 🤖
            <br />
            Press Escape or click outside to close.
          </p>

        </div>
      </div>
    </div>
  );
};

export default RateMeOverlay;